import styled, { css, keyframes } from 'styled-components';

export const LogsList = styled.ul`
  overflow-y: auto;
  overflow-y: overlay;
  padding: 1rem 2rem 0 2rem;
  overflow-y: scroll;
  flex: 1;
  li {
    margin-bottom: 1rem;
  }
`;
LogsList.displayName = 'LogsList';

export const FinishWrapper = styled.div`
  margin-top: 2rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
`;
FinishWrapper.displayName = 'FinishWrapper';

const bounceAnim = keyframes`
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-8px);
  }
`;

export const LoadingIndicatorWrapper = styled.div`
  display: inline-block;
  border-radius: 0 16px 16px 16px;
  overflow: hidden;
`;

export const LoadingIndicator = styled.div`
  height: 30px;
  display: flex;
  gap: 2px;
  font-size: 1.6rem;
  padding: 0.5rem;
  background-color: var(--chat-item-bot-bg-color);
  color: var(--chat-item-bot-text-color);
  > span {
    display: inline-block;
    position: relative;
    bottom: 16px;
    animation-duration: 0.4s;
    animation-name: ${bounceAnim};
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
  > span:nth-child(2) {
    animation-delay: 0.1s;
  }
  > span:nth-child(3) {
    animation-delay: 0.2s;
  }
`;
